<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="sec-9"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Savior"><h1 class="chapter2" id="pz9-1"><a href="#/contents#ba_02" id="ab_02"><b>Savior</b></a></h1>
<p id="pz9-3">Not by works of righteousness which we have done, but according to His mercy He saved us, through the washing of regeneration and renewing of the Holy Spirit,</p>
<p id="pz9-4">whom He poured out on us abundantly through Jesus Christ our Savior.</p>
<p class="right" id="pz9-6"><em>Titus 3:5, 6</em></p>
<p id="pz9-7">And we have seen and testify that the Father has sent the Son as Savior of the world.</p>
<p class="right" id="pz9-8"><em>I John 4:14</em></p>
<p id="pz9-9">And my spirit has rejoiced in God my Savior.</p>
<p class="right" id="pz9-10"><em>Luke 1:47</em></p>
<p id="pz9-11">For we ourselves have heard Him and we know that this is indeed the Christ, the Savior of the world.</p>
<p class="right" id="pz9-12"><em>John 4:42b</em></p>
<p id="pz9-13">For the Son of Man has come to seek and to save that which was lost.</p>
<p class="right" id="pz9-14"><em>Luke 19:10</em></p>
<p id="pz10-1">For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life.</p>
<p class="right" id="AN8"><em>John 3:16</em></p>
<p id="pz10-2">Being justified freely by His grace through the redemption that is in Christ Jesus,</p>
<p id="pz10-3">whom God set forth as a propitiation by His blood, through faith, to demonstrate His righteousness, because in His forbearance God had passed over the sins that were previously committed.</p>
<p class="right" id="pz10-4"><em>Romans 3:24, 25</em></p>
<p id="pz10-5">But God, who is rich in mercy, because of His great love with which He loved us,</p>
<p id="pz10-6">even when we were dead in trespasses, made us alive together with Christ (by grace you have been saved).</p>
<p class="right" id="pz10-7"><em>Ephesians 2:4, 5</em></p>
<p id="pz10-8">Most assuredly, I say to you, he who believes in Me has everlasting life.</p>
<p class="right" id="pz10-9"><em>John 6:47</em></p>
<p id="pz11-1">For by grace you have been saved through faith, and that not of yourselves; it is the gift of God,</p>
<p id="pz11-2">not of works, lest anyone should boast.</p>
<p class="right" id="pz11-3"><em>Ephesians 2:8, 9</em></p>
<p id="pz11-4">That if you confess with your mouth the Lord Jesus and believe in your heart that God has raised Him from the dead, you will be saved.</p>
<p class="right" id="AO5"><em>Romans 10:9</em></p>
<p id="pz11-5">Therefore, if anyone is in Christ, he is a new creation; old things have passed away; behold, all things have become new.</p>
<p class="right" id="pz11-6"><em>II Corinthians 5:17</em></p>
<p id="pz11-7">Who has saved us and called us with a holy calling, not according to our works, but according to His own purpose and grace which was given to us in Christ Jesus before time began.</p>
<p class="right" id="ASq"><em>II Timothy 1:9</em></p>
<p id="pz11-8">Nevertheless He saved them for His name’s sake, that He might make His mighty power known.</p>
<p class="right" id="pz11-9"><em>Psalm 106:8</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?4c17f87c